import { Instagram, Facebook } from "lucide-react";

export function FooterSocial() {
  return (
    <div className="lg:col-span-3">
      <p className="text-[10px] font-mono uppercase tracking-[0.28em] text-gold-light mb-5">Follow Along</p>
      <div className="flex gap-3">
        <a
          data-testid="social-instagram-link"
          href="https://instagram.com"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Instagram"
          className="rounded-full border border-alabaster/15 p-3 text-alabaster/70 hover:border-gold-light hover:text-gold-light transition-colors duration-300"
        >
          <Instagram size={16} />
        </a>
        <a
          data-testid="social-facebook-link"
          href="https://facebook.com"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Facebook"
          className="rounded-full border border-alabaster/15 p-3 text-alabaster/70 hover:border-gold-light hover:text-gold-light transition-colors duration-300"
        >
          <Facebook size={16} />
        </a>
      </div>
      <p className="mt-6 text-[10px] font-mono uppercase tracking-[0.22em] text-alabaster/30">
        Gold Filled · Sterling Silver
      </p>
    </div>
  );
}
